import React, {useState} from "react";
import {Button, Modal, Table} from "antd";
import MapPopup from "../calculatedTransfer/calculatedTable/MapPopup";
import CalculatedTableDetail from "../calculatedTransfer/calculatedTable/CalculatedTableDetail";
import CourierTypeModal from "../calculatedTransfer/calculatedTable/CourierTypeModal";

const CompletedTransferDetail = ({open, setOpen, completedTransferDetail}) => {
    const [selectedMapData, setSelectedMapData] = useState(null);
    const [mileInformations, setMileInformations] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    return (
        <Modal
            title="Transfer Detayları"
            visible={open}
            onCancel={() => setOpen(false)}
            width="90%"
            footer={null}
        >
            <CalculatedTableDetail
                transferReferenceData={completedTransferDetail?.transferReference}
                setMileInformations={setMileInformations}
                showModal={showModal}
                setSelectedMapData={setSelectedMapData}
            />
            <CourierTypeModal
                mileInformations={mileInformations}
                modalState={[isModalOpen, setIsModalOpen]}
            />
            {selectedMapData && (
                <MapPopup
                    encodedPolylines={selectedMapData}
                    onClose={() => setSelectedMapData(null)}
                />
            )}
        </Modal>
    );
};

export default CompletedTransferDetail;
